import React, { Component } from 'react';
import './styles.css';

class SalesProgramLayout extends Component {
	render() {
		return <div className="sales-program-layout">{this.props.children}</div>;
	}
}

export default SalesProgramLayout;
